import styled from 'styled-components'

interface ContainerProps {
  open?: boolean
  hidden?: boolean
}

interface ButtonPros {
  isDelete?: boolean
}

export const Container = styled.div<ContainerProps>`
  position: fixed;
  top: 0;
  left: 0;

  width: 100vw !important;
  height: 100vh !important;

  z-index: 200;

  background: rgba(0, 0, 0, 0.5);

  transition: transform 0.5s ease-in-out;
  transform: ${({ open }) => (open ? 'translateY(0)' : 'translateY(-100%)')};
`

export const Content = styled.div<ContainerProps>`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  max-width: 400px;

  background: #fff;
  border-radius: 8px;
  margin: auto;
  padding: 1rem;
`
export const ImageStudent = styled.img`
  min-width: 12rem;
  min-height: 12rem;
  transition: transform 0.2s;
  margin-bottom: 2rem;
  object-fit: cover;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-evenly !important;
  padding: 1rem;
  width: 90% !important;

  svg {
    margin: 0.5rem 1rem 0 auto;
    background: none;
    color: #aaa;
  }
`

export const ButtonImage = styled.button<ButtonPros>`
  color: white;
  font-weight: 700;
  background: ${(props) => (props.isDelete ? '#FF0000' : '#1d4051')};
  padding: 10px;
  min-width: 100px;
  border: none;
  border-radius: 8px;
`

export const InputAvatar = styled.input`
  display: none;
`

export const ErrorType = styled.h5`
  .errorType {
    width: 100%;
    color: red;
  }
`
